import { Dialog, DialogContent } from "../ui/dialog";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const PhotoViewer = ({ photos, index, onClose, onIndexChange }) => {
  const open = index !== null && index !== undefined && index >= 0 && photos?.length > 0;
  if (!open) return null;
  const safeIndex = Math.min(index, photos.length - 1);
  const photo = photos[safeIndex];
  const goPrev = () => onIndexChange((safeIndex - 1 + photos.length) % photos.length);
  const goNext = () => onIndexChange((safeIndex + 1) % photos.length);

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-3xl p-2 sm:p-4 bg-black/95 border-none" data-testid="photo-viewer">
        <DialogTitle className="sr-only">Project photo viewer</DialogTitle>
        <div className="relative flex items-center justify-center min-h-[300px]">
          {photos.length > 1 && (
            <button
              type="button"
              onClick={goPrev}
              className="absolute left-2 z-10 p-2 rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors"
              data-testid="photo-viewer-prev"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>
          )}
          <img
            src={photo.src}
            alt={photo.caption || photo.name || "Project photo"}
            className="max-h-[70vh] max-w-full object-contain rounded-lg"
            data-testid="photo-viewer-image"
          />
          {photos.length > 1 && (
            <button
              type="button"
              onClick={goNext}
              className="absolute right-2 z-10 p-2 rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors"
              data-testid="photo-viewer-next"
            >
              <ChevronRight className="w-6 h-6" />
            </button>
          )}
        </div>
        <div className="text-center text-white/80 text-sm px-4 pb-2">
          {photo.caption && <p className="mb-1">{photo.caption}</p>}
          <p className="text-white/50 text-xs">
            {safeIndex + 1} of {photos.length}
            {photo.name ? ` • ${photo.name}` : ""}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
